export class Session {
  userid;
  secretkey: string;
  token: string;
  about: string
  city: string
  createdDate: string
  currency: number
  displayName: string
  emailId: string
  enableResBank: number
  firstName: string
  icrAdmin: number
  icrSuperAdmin: number
  isBuyer: number
  isGroupAdmin: number
  isMessages: number
  isReferralMember: number
  isSeller: number
  isTranslator: number
  jobAdmin: number
  jobTitle: string
  lastName: string
  lastUpdatedDate: string
  latitude;
  lngRights;
  longitude;
  loyaltyPoints: number
  membershipId: string
  membershipStatus: number
  membershipStatusName: string
  mobileIsd: string
  mobileNumber: string
  organization: string
  profilePicture: string
  resId: number
  secretKey: string
  sellerList;
  userId: number
  userName;
  whatsappShareContent: string;
  emailShareContentSubject: string;
  emailShareContentMailBody: string;
  announcement: any;

  setData(obj) {
    if (obj) {
      this.secretkey = obj.secretKey;
      this.secretKey = obj.secretKey
      this.token = obj.token;
    }
  }

  setUserDetails(obj) {
    if (obj) {
      this.token = obj.token || null;
      this.about = obj.about;
      this.city = obj.city;
      this.createdDate = obj.createdDate;
      this.currency = obj.currency;
      this.displayName = obj.displayName;
      this.emailId = obj.emailId;
      this.enableResBank = obj.enableResBank;
      this.firstName = obj.firstName;
      this.icrAdmin = obj.icrAdmin;
      this.icrSuperAdmin = obj.icrSuperAdmin;
      this.isBuyer = obj.isBuyer;
      this.isGroupAdmin = obj.isGroupAdmin;
      this.isMessages = obj.isMessages;
      this.isReferralMember = obj.isReferralMember;
      this.isSeller = obj.isSeller;
      this.isTranslator = obj.isTranslator;
      this.jobAdmin = obj.jobAdmin;
      this.jobTitle = obj.jobTitle;
      this.lastName = obj.lastName;
      this.lastUpdatedDate = obj.lastUpdatedDate;
      this.latitude = obj.latitude;
      this.lngRights = obj.lngRights;
      this.longitude = obj.longitude;
      this.loyaltyPoints = obj.loyaltyPoints;
      this.membershipId = obj.membershipId;
      this.membershipStatus = obj.membershipStatus;
      this.membershipStatusName = obj.membershipStatusName;
      this.mobileIsd = obj.mobileIsd;
      this.mobileNumber = obj.mobileNumber;
      this.organization = obj.organization;
      this.profilePicture = obj.profilePicture;
      this.resId = obj.resId;
      this.secretKey = obj.secretKey;
      this.secretkey = obj.secretKey;
      this.sellerList = obj.sellerList;
      this.userId = obj.userId;
      this.userName = obj.firstName + '' + obj.lastName;
      this.whatsappShareContent = obj.whatsappShareContent;
      this.emailShareContentSubject = obj.emailShareContentSubject;
      this.emailShareContentMailBody = obj.emailShareContentMailBody;
      this.announcement = obj.announcement;

      try {
        if (obj.resId) {
          sessionStorage.setItem('resId', obj.resId)
        }
      }
      catch (err) {

      }
    }
  }

  getUserDetails() {
    return {
      userName: (this.firstName || ''),
      secretkey: this.secretkey,
      token: this.token,
      firstName: this.firstName,
      resId: this.resId,
      whatsappShareContent: this.whatsappShareContent,
      emailShareContentSubject: this.emailShareContentSubject,
      emailShareContentMailBody: this.emailShareContentMailBody,
      membershipId: this.membershipId,
      announcement: this.announcement,
      secretKey: this.secretkey,
      mobileIsd: this.mobileIsd,
      emailId: this.emailId,
      mobileNumber: this.mobileNumber

    };
  }
}
